export default __webpack_public_path__ + "static/media/photodune-4leZfb1R-three-little-corellas-on-a-branch-xl-comp.454676f6.jpg";